// custom typefaces
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/vt323/400.css';
import '@fontsource/press-start-2p/400.css';

export const onClientEntry = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }
};

export const onRouteUpdate = () => {
  requestAnimationFrame(() => {
    document.querySelectorAll('[data-main-image]').forEach((img) => {
      if (img.complete && img.style.opacity !== '1') {
        img.style.opacity = '1';
        const placeholder = img
          .closest('[data-gatsby-image-wrapper]')
          ?.querySelector('[data-placeholder-image]');
        if (placeholder) {
          placeholder.style.opacity = '0';
        }
      }
    });
  });
};
